document.addEventListener('DOMContentLoaded', () => {
  const contactForm = document.querySelector('form.contact-form__form');
  const button = contactForm.querySelector('button');
  const inputs = contactForm.querySelectorAll('input');
  const textarea = contactForm.querySelector('textarea');
  const select = contactForm.querySelector('select.input');

  if (inputs) {
    inputs.forEach((input) => {
      const inputValue = input.value;
      if (inputValue !== '') {
        const wrapper = input.closest('.contact-form__input-wrapper');
        if (wrapper) {
          wrapper.classList.add('filled');
        }
      }
    });
  }

  /**
   * @param select
   * @param input
   */
  function selectValidation(input) {
    const errorMsg = input.closest('.contact-form__input-wrapper').querySelector('.error-msg');
    if (input.value === 'false') {
      input.classList.add('error');
      if (errorMsg) {
        errorMsg.classList.remove('hidden');
      }
      return false;
    }

    input.classList.remove('error');
    if (errorMsg) {
      errorMsg.classList.add('hidden');
    }
    return true;
  }
  /**
   * @param input
   */
  function validateTextArea(input) {
    const errorMsg = input.closest('.contact-form__input-wrapper').querySelector('.error-msg');
    if (input.value.includes('<script>') || input.value.length < 30) {
      input.classList.add('error');
      errorMsg.classList.remove('hidden');
      return false;
    }
    input.classList.remove('error');
    errorMsg.classList.add('hidden');
    return true;
  }

  /**
   * @param inputs
   */
  // eslint-disable-next-line no-shadow
  function formValidation(inputs) {
    inputs.forEach((input) => {
      const wrapper = input.closest('.contact-form__input-wrapper');
      const errorMsg = wrapper ? wrapper.querySelector('.error-msg') : null;
      if (input.type === 'email') {
        // eslint-disable-next-line no-use-before-define
        if (input.value === '' || !validateEmail(input.value)) {
          input.classList.add('error');
          if (errorMsg) {
            errorMsg.classList.remove('hidden');
          }
        } else {
          input.classList.remove('error');
          if (errorMsg) {
            errorMsg.classList.add('hidden');
          }
        }
      } else if (input.required && input.value.trim() === '') {
        input.classList.add('error');
        if (errorMsg) {
          errorMsg.classList.remove('hidden');
        }
      } else {
        input.classList.remove('error');
        if (errorMsg) {
          errorMsg.classList.add('hidden');
        }
      }
    });
    selectValidation(select);
    validateTextArea(textarea);
  }

  /**
   * @param email
   */
  function validateEmail(email) {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  }

  /**
   * @param event
   */
  function handleInputChange(event) {
    const input = event.target;
    const wrapper = input.closest('.contact-form__input-wrapper');
    if (input.value.trim() !== '') {
      wrapper.classList.add('filled');
    } else {
      wrapper.classList.remove('filled');
    }
  }

  if (inputs) {
    inputs.forEach((element) => {
      element.addEventListener('input', handleInputChange);
    });
  }

  if (textarea) {
    textarea.addEventListener('input', handleInputChange);
  }

  if (contactForm) {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      formValidation(inputs);
      const errorMsg = button.closest('.contact-form__input-wrapper').querySelector('.error-msg');

      if (selectValidation(select) && validateTextArea(textarea)) {
        contactForm.submit();
        if (errorMsg) {
          errorMsg.classList.add('hidden');
        }
      } else if (errorMsg) {
        errorMsg.classList.remove('hidden');
      }
    });
  }
});
